import React, { useRef } from "react";

export default function FileTaskInput({ task, value, onChange, error }) {
  const inputRef = useRef();

  const handleFile = (file) => {
    if (!file) {
      onChange(null);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      onChange({
        fileName: file.name,
        fileSize: file.size,
        fileDataUrl: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleChange = (e) => {
    const file = e.target.files && e.target.files[0];
    handleFile(file);
  };

  const acceptAttr =
    task.fileTypes && task.fileTypes.length > 0
      ? task.fileTypes.map((t) => "." + t).join(",")
      : undefined;

  return (
    <div className="task-item">
      <label>
        {task.title}
        {task.mandatory && <span className="required">*</span>}
      </label>
      <div className="file-input-wrapper">
        <input
          type="file"
          accept={acceptAttr}
          ref={inputRef}
          onChange={handleChange}
          style={{ display: "none" }}
        />
        <button
          className="btn-secondary"
          onClick={() => inputRef.current && inputRef.current.click()}
        >
          {value ? "Change file" : "Choose file"}
        </button>
        {value && (
          <span className="file-chip">
            {value.fileName} ({Math.round(value.fileSize / 1024)} KB)
            <button className="file-chip-remove" onClick={() => onChange(null)}>
              ×
            </button>
          </span>
        )}
      </div>
      {error && <div className="error-text">{error}</div>}
    </div>
  );
}
